export const EMAIL_DELIVERY_STATUS = {
  PENDING: "pending",
  SENT: "sent",
  FAILED: "failed",
};

export default {
  EMAIL_DELIVERY_STATUS,
};
